import React from "react";

import { useFormikContext } from "formik";
import { Template } from "../../../../../models";

import SwitchContainer from "../../common/SwitchContainer";

export default function ImageExcludeTextToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <SwitchContainer
      title="Attempt to exclude words and text"
      enabled={values.excludeImageText || false}
      setEnabled={() => {
        setFieldValue("excludeImageText", !values?.excludeImageText);
      }}
    />
  );
}
